<template>
  <div class="text-center">
    <v-dialog v-model="confirmationDialog" persistent>
      <template v-slot:activator="{ on, attrs }">
        <Tooltip
          v-on="on"
          v-bind="attrs"
          id="delete"
          :type="isMobile ? 'icon' : 'button'"
          icon="delete"
          :tooltipText="$t('shooting.buttons.deleteShooting')"
          :tooltipButtonText="$t('shooting.buttons.deleteShooting')"
          v-on:tooltipdelete="deleteShooting"
        />
      </template>
    </v-dialog>

    <DeleteShootingConfirmationModal
      :dialog="confirmationDialog"
      @delete-images="confirmDeletion"
      @close-dialog="closeConfirmDialog"
    />
  </div>
</template>

<script>
import Tooltip from '@/components/common/atoms/Tooltip'
import DeleteShootingConfirmationModal from '@/components/shooting/deleteShooting/DeleteShootingConfirmationModal'
export default {
  name: 'DeleteShooting',

  props: {
    shootingId: {
      type: String,
      required: true
    }
  },

  components: {
    Tooltip,
    DeleteShootingConfirmationModal
  },

  data() {
    return {
      loading: false,
      confirmationDialog: false
    }
  },

  methods: {
    closeConfirmDialog() {
      this.confirmationDialog = false
    },
    async deleteShooting() {
      this.confirmationDialog = true
    },
    async confirmDeletion() {
      this.confirmationDialog = false

      this.loading = true

      await this.$store.dispatch('deleteShooting', {
        ownerId: this.$route.params.ownerId,
        productId: this.$route.params.productId,
        shootingId: this.$route.params.shootingId
      })
      this.loading = false
      this.$router.push('/shootings')
    }
  },

  computed: {
    isMobile() {
      const width = window.innerWidth > 0 ? window.innerWidth : screen.width
      return width < 750
    }
  }
}
</script>
